import _CODE3 from "./CODE93.js";
import _CODE93FullASCII3 from "./CODE93FullASCII.js";
var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CODE93FullASCII = exports.CODE93 = undefined;
var _CODE = _CODE3;
var _CODE2 = _interopRequireDefault(_CODE);
var _CODE93FullASCII = _CODE93FullASCII3;
var _CODE93FullASCII2 = _interopRequireDefault(_CODE93FullASCII);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
exports.CODE93 = _CODE2.default;
exports.CODE93FullASCII = _CODE93FullASCII2.default;
export default exports;